// components/SuccessModal.js
"use client";

import ModalWrapper from "../../Neighborhood/[id]/ModalWrapper";

export default function SuccessModal({
  ismodalopen,
  closeModalsucess,
  customStylesReview,
}) {
  return (
    <div className="success_modal">
      <ModalWrapper
        isOpen={ismodalopen}
        onRequestClose={closeModalsucess}
        style={customStylesReview}
        contentLabel="Success Modal"
      >
        <div className="review-model-main">
          <div className="model_review_feedback">
            Please check your email and click verify.
            <p>Your review will be posted soon!</p>
          </div>
        </div>

        <div className="review_model_close_btn">
          <a onClick={closeModalsucess}>Close</a>
        </div>
      </ModalWrapper>
    </div>
  );
}
